import React from "react";
import { Title, SimpleGrid, Center, Tabs } from "@mantine/core";
import Course from "../../components/blog/Course";
import { COURSES } from "../../constants/courses";
import "./BlogPage.css"; // Import the CSS file
import { useMediaQuery } from '@mantine/hooks';

export default function BlogPage() {
  const isMobile = useMediaQuery('(max-width: 1090px)');
  console.log(COURSES);

  return (
    <div>
      <div className="blog-title">
        <Title order={2}>Learning Hub</Title>
      </div>
      <div className="blog-page-container">
        <div className="blog-card-wrapper">
          <Tabs defaultValue="trading"  color="orange">
            <Tabs.List grow position="apart">
              <Tabs.Tab value="trading" fw={700}>
                Learn Trading
              </Tabs.Tab>
              <Tabs.Tab value="blockchain" fw={700}>
                Learn Blockchain
              </Tabs.Tab>
              <Tabs.Tab value="algo_trading" fw={700}>
                Learn Algo Trading
              </Tabs.Tab>
            </Tabs.List>
            <Tabs.Panel value="trading" pt="xs">
              {!isMobile && <SimpleGrid
                cols={3}
                sx={{ width: "100%", justifyContent: "center" }}
              >
                {COURSES.map((course, index) => (
                  <Center key={index}>
                    <Course {...course} />
                  </Center>
                ))}
              </SimpleGrid>}
              {isMobile && <SimpleGrid
                cols={1}
                sx={{ width: "100%", justifyContent: "center" }}
              >
                {COURSES.map((course, index) => (
                  <Center key={index}>
                    <Course {...course} />
                  </Center>
                ))}
              </SimpleGrid>}
            </Tabs.Panel>
            <Tabs.Panel value="blockchain" pt="xs">
            `{!isMobile && <SimpleGrid
                cols={3}
                sx={{ width: "100%", justifyContent: "center" }}
              >
                {/* Insert data here */}
              </SimpleGrid>}
              {isMobile && <SimpleGrid
                cols={1}
                sx={{ width: "100%", justifyContent: "center" }}
              >
                {/* Insert data here */}
              </SimpleGrid>}
            </Tabs.Panel>
            <Tabs.Panel value="algo_trading" pt="xs">
              {!isMobile && <SimpleGrid
                cols={3}
                sx={{ width: "100%", justifyContent: "center" }}
              >
                {COURSES.map((course, index) => (
                  <Center key={index}>
                    <Course {...course} />
                  </Center>
                ))}
              </SimpleGrid>}
              {isMobile && <SimpleGrid
                cols={1}
                sx={{ width: "100%", justifyContent: "center" }}
              >
                {COURSES.map((course, index) => (
                  <Center key={index}>
                    <Course {...course} />
                  </Center>
                ))}
              </SimpleGrid>}
            </Tabs.Panel>
          </Tabs>
        </div>
      </div>
    </div>
  );
}